module.exports = __webpack_public_path__ + "img/mind_skeleton_time_13.34f0d12c.png";